/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocalDate } from '../../models/local-date';
import { TerytSimcTo } from '../../models/teryt-simc-to';

export interface ApiWebTerytMiejscaSimcGet$Params {
  simc: string;
  date?: LocalDate;
}

export function apiWebTerytMiejscaSimcGet(http: HttpClient, rootUrl: string, params: ApiWebTerytMiejscaSimcGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TerytSimcTo>> {
  const rb = new RequestBuilder(rootUrl, apiWebTerytMiejscaSimcGet.PATH, 'get');
  if (params) {
    rb.path('simc', params.simc, {});
    rb.query('date', params.date, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TerytSimcTo>;
    })
  );
}

apiWebTerytMiejscaSimcGet.PATH = '/api/web/teryt/miejsca/{simc}';
